import { useEffect } from "react";

// Lightweight SEO manager for the SPA: sets title, meta description,
// Open Graph / Twitter tags, canonical URL and optional JSON-LD schema.
function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function SEO({ title, description, image, path = "", schema }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Web Vantage Enterprises` : "Web Vantage Enterprises | Premium Digital Agency";
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);

    const canonicalHref = `https://webvantagenterprises.com${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalHref);

    let scriptEl;
    if (schema) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.setAttribute("data-seo-schema", "true");
      scriptEl.text = JSON.stringify(schema);
      document.head.appendChild(scriptEl);
    }
    return () => {
      if (scriptEl) document.head.removeChild(scriptEl);
    };
  }, [title, description, image, path, schema]);

  return null;
}
